import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { store } from './store';
import { setLanguage } from './store/languageSlice';
import enTranslation from './locales/en.json';
import deTranslation from './locales/de.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      de: { translation: deTranslation },
    },
    lng: store.getState().language.currentLanguage,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lng) => {
  store.dispatch(setLanguage(lng));
});

export default i18n;
